import { useDigitalConsultationStore } from '@/store/useDigitalConsultationStore'
import { useDuplicateScheduleStore } from '@/store/useDuplicateScheduleStore'
import { useGenericErrorStore } from '@/store/useGenericErrorStore'
import { useScheduleCancelStore } from '@/store/useScheduleCancelStore'
import { useScheduleStore } from '@/store/useScheduleStore'
import { useStepbarStore } from '@/store/useStepbarStore'
import { getAccessToken } from '@/utils/helpers/storageHelpers'

type RouteChecker = (args?) => boolean

export const routeRequirements: Record<string, RouteChecker> = {
  '/confirmar-paciente': () => {
    const { slot } = useScheduleStore.getState()
    return Boolean(slot?.id)
  },
  '/sucesso-agendamento': () => {
    const { slot } = useScheduleStore.getState()
    return Boolean(slot?.id)
  },
  '/confirmar-horario': () => {
    const { slot } = useScheduleStore.getState()
    return Boolean(slot?.id)
  },
  '/cancelar-consulta': (pathName) => {
    return /^\/cancelar-consulta\/[^/]+/.test(pathName || '')
  },
  '/consulta-cancelada': () => {
    const { data } = useScheduleCancelStore.getState()
    return Boolean(data?.id)
  },
  '/escolha-usuario': () => {
    const token = getAccessToken()
    return Boolean(token)
  },
  '/teleconsulta': (pathName) => {
    return /^\/teleconsulta\/(paciente|medico)\/[^/]+/.test(pathName || '')
  },
  '/escolha-horario': () => {
    const schedules = useDuplicateScheduleStore.getState().schedules
    return schedules.length > 1
  },
  '/fallback': (pathName) => {
    const patternGenericError = /fallback\/erro-generico/
    const isPathGenericError = patternGenericError.test(pathName)
    const { flowStart } = useScheduleStore.getState()

    if (isPathGenericError && flowStart) {
      return true
    }

    const ERR_CODES = ['SCHEDULE_CANCELLED', 'REQUISITION_CANCELLED']

    const { stepWithError } = useStepbarStore.getState()
    const { data } = useScheduleCancelStore.getState()
    const { errorSocket, error } = useGenericErrorStore.getState()
    const { patientName } = useDigitalConsultationStore.getState()

    const isAlreadyCancelled = ERR_CODES.includes(
      error?.response?.data?.code || ''
    )

    const canNext = Boolean(
      stepWithError?.length ||
        errorSocket?.error ||
        patientName ||
        data?.id ||
        isAlreadyCancelled
    )

    return Boolean(canNext)
  }
}
